import Decimal from 'decimal.js';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { HttpService } from '../service/http.service';
import { PaymentReceivedAmountSearchOption } from '../payment-received-amount-search-option';
import { PaymentReceivedAmountSearchRule } from '../payment-received-amount-search-rule';
import { PaymentReceivedDateSearchOption } from '../payment-received-date-search-option';
import { PaymentReceivedDateSearchRule } from '../payment-received-date-search-rule';
import { PaymentReceivedLineItem } from '../payment-received-line-item';
import { PaymentReceivedSearchRules } from '../payment-received-search-rules';
import { ToastMessageService } from '../toast-message.service';
import { PaymentReceivedTextSearchRule } from '../payment-received-text-search-rule';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-transactions-payment-received',
  templateUrl: './transactions-payment-received.component.html',
  styleUrls: ['./transactions-payment-received.component.css']
})
export class TransactionsPaymentReceivedComponent implements OnInit {

  payments: PaymentReceivedLineItem[] = [];
  dateOptions: PaymentReceivedDateSearchOption[] = [];
  amountOptions: PaymentReceivedAmountSearchOption[] = [];
  searchForm!: FormGroup;
  @ViewChild('dataTable') table!: Table;

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder,
    private toastService: ToastMessageService
  ) { }

  ngOnInit(): void {
    this.dateOptions = [
      new PaymentReceivedDateSearchOption(1, "Between"),
      new PaymentReceivedDateSearchOption(2, "On")
    ];
    this.amountOptions = [
      new PaymentReceivedAmountSearchOption(1, "Equals"),
      new PaymentReceivedAmountSearchOption(2, "Greater than"),
      new PaymentReceivedAmountSearchOption(3, "Less than"),
      new PaymentReceivedAmountSearchOption(4, "Between")
    ];
    this.initSearchForm();
    this.getByYear(moment().year().toString());
  }

  getByYear(year: string) {
    this.httpService.getPaymentLineItemsByYear(year).subscribe(res => {
      this.payments = res;
    });
  }

  initSearchForm() {
    this.searchForm = this.builder.group({
      dateOption: null,
      dateOnValue: null,
      dateFromValue: null,
      dateToValue: null,
      amountOption: null,
      amountValue: null,
      amountMinValue: null,
      amountMaxValue: null,
      textValue: null
    });
  }

  doCustomSearch() {
    if (this.searchForm.invalid) {
      this.toastService.addError("Error", "Form value is invalid");
      return;
    }
    let searchRules = new PaymentReceivedSearchRules(null, null, null);
    if (this.searchForm.value.dateOption) {
      switch (this.searchForm.value.dateOption.id) {
        case 1:
          if (this.searchForm.value.dateFromValue != null && this.searchForm.value.dateToValue != null) {
            searchRules.dateSearch = new PaymentReceivedDateSearchRule(null, moment(this.searchForm.value.dateFromValue).utc(true),
             moment(this.searchForm.value.dateToValue).utc(true), this.searchForm.value.dateOption);
          } else {
            this.toastService.addError("Error", "Date is not complete");
            return;
          }
          break;
        case 2:
          if (this.searchForm.value.dateOnValue != null) {
            searchRules.dateSearch = new PaymentReceivedDateSearchRule(moment(this.searchForm.value.dateOnValue).utc(true), null, null, this.searchForm.value.dateOption);
          } else {
            this.toastService.addError("Error", "Date is empty");
            return;
          }
          break;
      }
    }
    if(this.searchForm.value.amountOption){
      switch(this.searchForm.value.amountOption.id){
        case 1:
          case 2: 
          case 3:
            if(this.searchForm.value.amountValue){
              searchRules.amountSearch = new PaymentReceivedAmountSearchRule(new Decimal(this.searchForm.value.amountValue), null, null, this.searchForm.value.amountOption);
            } else {
              this.toastService.addError("Error", "Amount is empty");
              return;
            }
            break;
            case 4:
              if(this.searchForm.value.amountMaxValue && this.searchForm.value.amountMinValue){
                searchRules.amountSearch = new PaymentReceivedAmountSearchRule(null, new Decimal(this.searchForm.value.amountMinValue), new Decimal(this.searchForm.value.amountMaxValue), this.searchForm.value.amountOption);
              } else {
                this.toastService.addError("Error", "Max amount or min amount is missing");
                return;
              }
      }
    }
    if(this.searchForm.value.textValue && this.searchForm.value.textValue.length > 0 && this.searchForm.value.textValue.length != ""){
      searchRules.textSearch = new PaymentReceivedTextSearchRule(this.searchForm.value.textValue);
    }
    if(!searchRules.textSearch && !searchRules.dateSearch && !searchRules.amountSearch){
      this.toastService.addError("Error", "You should chose at least one search option.");
      return;
    }

    this.httpService.getCustomPaymentLineItems(searchRules).subscribe(res => {
      this.payments = res;
    });
  }

  resetOptions() {
    this.initSearchForm();
    this.getByYear("2022");
  }

  onPaymentDateSelect(value: Date) {
    this.table.filter(moment(value).format("YYYY-MM-DD"), 'date', 'equals');
  }

  onStartDateSelect(value: Date) {
    this.table.filter(moment(value).format("YYYY-MM-DD"), 'startDate', 'equals');
  }

}
